import { useContext, useEffect, useState } from 'react';
import {
  Fab,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';

import {
  CopyAll as CopyAllIcon,
} from '@mui/icons-material';

import { getDatabase, ref, set, push, onValue } from "firebase/database";
import { AuthContext } from 'components';

const db = getDatabase();

export const CopyModal = (props) => {
  const { items, selected } = props;
  const [ open, setOpen ] = useState(false);
  const [ saving, setSaving ] = useState(false);
  const [ seasonLimit, setSeasonLimit ] = useState(3);
  const { copyItem, account, seasons, selectedStore, selectedSeason, selectedCollection, sortByDisplayOrder, notify } = useContext(AuthContext)
  const [ localCollections, setLocalCollections ] = useState([])
  const [ newStore, setNewStore ] = useState(selectedStore)
  const [ newSeason, setNewSeason ] = useState(selectedSeason)
  const [ newCollection, setNewCollection ] = useState(selectedCollection)

  useEffect(() => {
    if (Object.keys(seasons).sort((a, b) => seasons[b].displayOrder - seasons[a].displayOrder).slice(0, seasonLimit).indexOf(selectedSeason) === -1) {
      setSeasonLimit(Object.keys(seasons).length);
    }
  }, [])

  useEffect(() => {
    const collections_ref = ref(db, 'accountCollections/' + newStore + '/' + newSeason);
    onValue(collections_ref, (snapshot) => {
      const data = snapshot.val() || [];
      setLocalCollections({
        'all': { displayName: 'No Collection' },
        ...data
      })
    })
  }, [newStore, newSeason])

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  }

  const handleAction = () => {
    if (!selected) {
      return
    }

    let bulk_action = []

    items.forEach((item) => {
      bulk_action.push(new Promise((resolve, rejejct) => {
        copyItem({
          ...item,
          collectionId: newCollection !== 'all' ? newCollection : null
        }, { store: newStore, season: newSeason }, resolve)
      }))
    })

    Promise.all(bulk_action).then(() => {
      handleClose()
      notify({
        message: `${items.length} product(s) copied to ${account.acctStores[newStore].displayName}/${seasons[newSeason].displayName}`
      })
    })
  };
 
  return (
    <>
      <MenuItem onClick={handleOpen} component="div" disabled={!selected} color="warning" aria-label="add">
        {/* <CopyAllIcon onClick={handleOpen} /> */}
        <div>Copy</div>
      </MenuItem>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          Choose where you want to copy {items.length} {`item${items.length > 1 ? 's' : ''}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ textAlign: 'center' }}>
            {/* Store selection */}
            <FormControl fullWidth variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={newStore}
                onChange={(e) => setNewStore(e.target.value)}
                label="Store"
              >
                {Object.keys(account.acctStores).map((s) => <MenuItem key={`store-${account.acctStores[s].displayName}`} value={s}>{account.acctStores[s].displayName}</MenuItem>)}
              </Select>
            </FormControl>
            {/* Season selection */}
            <FormControl fullWidth variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={newSeason}
                onChange={(e) => setNewSeason(e.target.value)}
                label="Season"
              >
                {Object.keys(seasons).sort((a, b) => seasons[b].displayOrder - seasons[a].displayOrder).slice(0, seasonLimit).map((s) => <MenuItem key={`season-${seasons[s].displayName}`} value={s}>{seasons[s].displayName}</MenuItem>)}
                {seasonLimit === 3 && <MenuItem onClickCapture={(e) => { setSeasonLimit(Object.keys(seasons).length); e.stopPropagation(); }} key={`season-show-more`} value={'show_more'}>Show more</MenuItem>}
              </Select>
            </FormControl>
            {/* Collection selection */}
            <FormControl fullWidth variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={newCollection}
                onChange={(e) => setNewCollection(e.target.value)}
                label="Collection"
              >
                {Object.keys(localCollections).map(e => ({ ...localCollections[e], id: e })).sort(sortByDisplayOrder).map((s) => <MenuItem key={`collection-${s.displayName}`} value={s.id}>{s.displayName}</MenuItem>)}
              </Select>
            </FormControl>
          </DialogContentText>
          
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => { setSaving(true); setTimeout(handleAction, 200) }} autoFocus>Duplicate</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}